export default {

  General_information: ' General information',
  Services: '  Services',
  ALL_SERVICES: 'ALL THE SERVICES'


}